import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export function AdminRoute({ children }) {
    const { user, loading } = useAuth();

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
            </div>
        );
    }

    // Check if user is admin
    // Admin users have type: 'admin' and role should be 'admin' (role name from API)
    if (!user || user.type !== 'admin') {
        return <Navigate to="/" replace />;
    }
    
    // Additional check: role should be 'admin'
    if (user.role && user.role !== 'admin') {
        return <Navigate to="/" replace />;
    }

    return children;
}
